import { ContainerLayout } from '@layouts';
import * as animationData from '@lottie/technologyTagline.json';
import dynamic from 'next/dynamic';
import styles from './styles.module.scss';

const PlayerWithNoSSR = dynamic(() => import('react-lottie').then((module) => module), {
  ssr: false,
});

export const QuoteContent = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <ContainerLayout
      outerContainerClassName={styles.outerContainer}
      innerContainerClassName={styles.innerContainer}
    >
      <h3>From SMEs to MNCs,</h3>
      <h4>
        <span> We empowering today’s workplace</span>
        <span>
          with cutting-edge <span className="hidden">Technology.</span>
          <div className={styles.animation}>
            <PlayerWithNoSSR isClickToPauseDisabled options={defaultOptions} width="100%" />
          </div>
        </span>
      </h4>
    </ContainerLayout>
  );
};

QuoteContent.displayName = 'QuoteContent';

export default QuoteContent;
